import React from 'react';
import { Link } from 'react-router-dom';

// Sources utilisées pour les quiz d'actualité
const NEWS_SOURCES = {
  france: [
    { name: "Le Monde", url: "https://www.lemonde.fr", type: "Presse nationale" },
    { name: "Le Figaro", url: "https://www.lefigaro.fr", type: "Presse nationale" },
    { name: "Libération", url: "https://www.liberation.fr", type: "Presse nationale" },
    { name: "France Info", url: "https://www.francetvinfo.fr", type: "Service public" },
    { name: "AFP", url: "https://www.afp.com", type: "Agence de presse" },
    { name: "Reuters", url: "https://www.reuters.com", type: "Agence de presse" },
    { name: "Les Échos", url: "https://www.lesechos.fr", type: "Presse économique" },
    { name: "L'Express", url: "https://www.lexpress.fr", type: "Newsmagazine" },
  ],
  afrique: [
    { name: "Jeune Afrique", url: "https://www.jeuneafrique.com", type: "Presse panafricaine" },
    { name: "RFI", url: "https://www.rfi.fr", type: "Radio internationale" },
    { name: "Le Monde Afrique", url: "https://www.lemonde.fr/afrique", type: "Presse internationale" },
    { name: "Agence Ecofin", url: "https://www.agenceecofin.com", type: "Presse économique" },
    { name: "APA News", url: "https://www.apanews.net", type: "Agence de presse" },
    { name: "Africa News", url: "https://www.africanews.com", type: "Télévision panafricaine" },
  ],
  sport: [
    { name: "L'Équipe", url: "https://www.lequipe.fr", type: "Presse sportive" },
    { name: "RMC Sport", url: "https://rmcsport.bfmtv.com", type: "Radio/TV sportive" },
    { name: "Eurosport", url: "https://www.eurosport.fr", type: "Télévision sportive" },
    { name: "So Foot", url: "https://www.sofoot.com", type: "Magazine football" },
  ],
  economie: [
    { name: "Les Échos", url: "https://www.lesechos.fr", type: "Presse économique" },
    { name: "La Tribune", url: "https://www.latribune.fr", type: "Presse économique" },
    { name: "BFM Business", url: "https://www.bfmtv.com/economie", type: "TV économique" },
    { name: "Capital", url: "https://www.capital.fr", type: "Magazine économique" },
  ],
  international: [
    { name: "AFP", url: "https://www.afp.com", type: "Agence de presse" },
    { name: "Reuters", url: "https://www.reuters.com", type: "Agence de presse" },
    { name: "BBC News", url: "https://www.bbc.com/news", type: "Service public britannique" },
    { name: "The Guardian", url: "https://www.theguardian.com", type: "Presse britannique" },
    { name: "New York Times", url: "https://www.nytimes.com", type: "Presse américaine" },
    { name: "Al Jazeera", url: "https://www.aljazeera.com", type: "Télévision internationale" },
  ]
};

const LegalPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-6">
        
        {/* Header */}
        <div className="text-center mb-12">
          <Link to="/" className="text-2xl font-bold text-blue-900">
            DailyGlobe School
          </Link>
          <h1 className="text-3xl font-bold text-gray-800 mt-6">Informations Légales</h1>
        </div>

        {/* Navigation */}
        <div className="flex flex-wrap justify-center gap-3 mb-8">
          <a href="#mentions" className="px-4 py-2 bg-blue-100 text-blue-800 rounded-lg hover:bg-blue-200">
            Mentions Légales
          </a>
          <a href="#cgu" className="px-4 py-2 bg-blue-100 text-blue-800 rounded-lg hover:bg-blue-200">
            CGU
          </a>
          <a href="#cgv" className="px-4 py-2 bg-blue-100 text-blue-800 rounded-lg hover:bg-blue-200">
            CGV
          </a>
          <a href="#sources" className="px-4 py-2 bg-blue-100 text-blue-800 rounded-lg hover:bg-blue-200">
            Sources
          </a>
        </div>

        {/* Mentions Légales */}
        <section id="mentions" className="bg-white rounded-xl shadow-sm p-8 mb-8">
          <h2 className="text-2xl font-bold text-gray-800 mb-6 border-b pb-4">Mentions Légales</h2>
          
          <div className="space-y-6 text-gray-700">
            <div>
              <h3 className="font-bold text-gray-800 mb-2">Éditeur du site</h3>
              <p><strong>Le Pool Presse SAS</strong></p>
              <p>Camp Saint Georges 9, la Farinière</p>
              <p>28240 Fontaine-Simon</p>
              <p>France</p>
            </div>

            <div>
              <h3 className="font-bold text-gray-800 mb-2">Directeur de la publication</h3>
              <p>Jean-Baptiste Giraud</p>
            </div>

            <div>
              <h3 className="font-bold text-gray-800 mb-2">Hébergement</h3>
              <p>Le site est hébergé par Emergent Labs</p>
              <p>Service Cloud Kubernetes</p>
            </div>

            <div>
              <h3 className="font-bold text-gray-800 mb-2">Contact</h3>
              <p>Email : contact@dailyglobe.school</p>
            </div>

            <div>
              <h3 className="font-bold text-gray-800 mb-2">Propriété intellectuelle</h3>
              <p>
                L'ensemble du contenu de ce site (textes, images, vidéos, logos, etc.) est protégé 
                par le droit d'auteur et appartient à Le Pool Presse SAS ou à ses partenaires. 
                Toute reproduction, représentation ou diffusion, totale ou partielle, du contenu 
                de ce site par quelque procédé que ce soit, sans l'autorisation expresse de 
                Le Pool Presse SAS, est interdite.
              </p>
            </div>

            <div>
              <h3 className="font-bold text-gray-800 mb-2">Protection des données personnelles</h3>
              <p>
                Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez 
                d'un droit d'accès, de rectification, de suppression et de portabilité de vos données 
                personnelles. Pour exercer ces droits, contactez-nous à : rgpd@dailyglobe.school
              </p>
            </div>
          </div>
        </section>

        {/* CGU */}
        <section id="cgu" className="bg-white rounded-xl shadow-sm p-8 mb-8">
          <h2 className="text-2xl font-bold text-gray-800 mb-6 border-b pb-4">
            Conditions Générales d'Utilisation (CGU)
          </h2>
          
          <div className="space-y-6 text-gray-700">
            <div>
              <h3 className="font-bold text-gray-800 mb-2">Article 1 - Objet</h3>
              <p>
                Les présentes Conditions Générales d'Utilisation (CGU) régissent l'accès et l'utilisation 
                de la plateforme pédagogique DailyGlobe School (ci-après "la Plateforme"), éditée par 
                Le Pool Presse SAS. La Plateforme est un logiciel en tant que service (SaaS) destiné 
                à l'enseignement du journalisme.
              </p>
            </div>

            <div>
              <h3 className="font-bold text-gray-800 mb-2">Article 2 - Accès à la Plateforme</h3>
              <p>
                L'accès à la Plateforme est réservé aux établissements d'enseignement (écoles de journalisme, 
                universités, centres de formation) ayant souscrit un abonnement, ainsi qu'à leurs étudiants 
                et enseignants dûment autorisés.
              </p>
            </div>

            <div>
              <h3 className="font-bold text-gray-800 mb-2">Article 3 - Services proposés</h3>
              <p>La Plateforme propose notamment :</p>
              <ul className="list-disc ml-6 mt-2 space-y-1">
                <li>Des quiz d'actualité générés par intelligence artificielle</li>
                <li>Des ateliers d'écriture journalistique</li>
                <li>Des simulateurs d'interview</li>
                <li>Des exercices de grammaire et d'orthographe</li>
                <li>Des ateliers d'investigation OSINT</li>
                <li>Des outils de suivi pédagogique pour les enseignants</li>
                <li>Un système de notation et de génération de bulletins</li>
                <li>Un journal scolaire numérique</li>
              </ul>
            </div>

            {/* DISCLAIMERS IMPORTANTS */}
            <div className="bg-amber-50 border-l-4 border-amber-500 p-4 my-6">
              <h3 className="font-bold text-amber-800 mb-2">Article 4 - Avertissements importants et limitation de responsabilité</h3>
              
              <div className="space-y-4 text-amber-900">
                <div>
                  <h4 className="font-semibold">4.1 - Contenus générés par intelligence artificielle</h4>
                  <p>
                    Les quiz, exercices, corrections et évaluations générés par intelligence artificielle 
                    sont fournis à titre pédagogique uniquement. L'éditeur <strong>ne garantit pas l'exactitude 
                    absolue</strong> des informations générées. Les utilisateurs sont encouragés à vérifier les 
                    informations dans le cadre de leur apprentissage journalistique, conformément aux principes 
                    de recoupement des sources.
                  </p>
                </div>

                <div>
                  <h4 className="font-semibold">4.2 - Sélection automatisée des sujets d'actualité</h4>
                  <p>
                    La sélection des sujets d'actualité utilisés pour les quiz est <strong>totalement neutre 
                    et automatisée</strong>. Elle repose sur l'agrégation de sources de presse (voir section "Sources"). 
                    Cette automatisation peut occasionnellement <strong>laisser passer des erreurs</strong> présentes 
                    dans les sources utilisées. DailyGlobe School ne saurait être tenu responsable des erreurs 
                    factuelles provenant des sources d'information tierces.
                  </p>
                </div>

                <div>
                  <h4 className="font-semibold">4.3 - Système de notation et bulletins</h4>
                  <p>
                    Le système de notation et de génération de bulletins proposé par la Plateforme est un 
                    <strong> outil d'aide à l'évaluation pédagogique</strong>. Il <strong>n'a pas vocation à se 
                    substituer</strong> au système de notation officiel de l'établissement d'enseignement. 
                    Les notes et appréciations générées par la Plateforme doivent être validées par l'enseignant 
                    avant toute utilisation officielle.
                  </p>
                </div>

                <div>
                  <h4 className="font-semibold">4.4 - Sauvegarde des données</h4>
                  <p>
                    DailyGlobe School <strong>recommande vivement</strong> aux établissements et enseignants de 
                    <strong> sauvegarder régulièrement</strong> les bulletins de notes et documents générés par 
                    la Plateforme. L'éditeur ne saurait être tenu responsable de la perte de données en cas 
                    de défaillance technique, d'interruption de service ou de résiliation d'abonnement.
                  </p>
                </div>

                <div>
                  <h4 className="font-semibold">4.5 - Limitation générale de responsabilité</h4>
                  <p>
                    Le Pool Presse SAS fournit la Plateforme "en l'état" et <strong>décline toute responsabilité</strong> :
                  </p>
                  <ul className="list-disc ml-6 mt-2 space-y-1">
                    <li>Pour les dommages directs ou indirects résultant de l'utilisation de la Plateforme</li>
                    <li>Pour les erreurs dans les contenus générés automatiquement</li>
                    <li>Pour les décisions pédagogiques prises sur la base des évaluations de la Plateforme</li>
                    <li>Pour la perte de données en cas de non-sauvegarde par l'utilisateur</li>
                    <li>Pour les interruptions de service liées à des maintenances ou cas de force majeure</li>
                  </ul>
                  <p className="mt-2">
                    La responsabilité totale de Le Pool Presse SAS est <strong>limitée au montant des sommes 
                    effectivement versées</strong> par le client au cours des 12 mois précédant le fait générateur.
                  </p>
                </div>
              </div>
            </div>

            <div>
              <h3 className="font-bold text-gray-800 mb-2">Article 5 - Propriété des travaux</h3>
              <p>
                Les articles et travaux produits par les étudiants sur la Plateforme restent leur 
                propriété intellectuelle. Cependant, en soumettant un article pour publication dans 
                le journal scolaire, l'étudiant accorde à DailyGlobe School une licence non exclusive 
                de diffusion à des fins pédagogiques.
              </p>
            </div>

            <div>
              <h3 className="font-bold text-gray-800 mb-2">Article 6 - Comportement des utilisateurs</h3>
              <p>Les utilisateurs s'engagent à :</p>
              <ul className="list-disc ml-6 mt-2 space-y-1">
                <li>Respecter les lois en vigueur</li>
                <li>Ne pas diffuser de contenus illicites, diffamatoires ou contraires aux bonnes mœurs</li>
                <li>Ne pas tenter de pirater ou perturber le fonctionnement de la Plateforme</li>
                <li>Ne pas utiliser la Plateforme à des fins autres que pédagogiques</li>
              </ul>
            </div>

            <div>
              <h3 className="font-bold text-gray-800 mb-2">Article 7 - Modification des CGU</h3>
              <p>
                Le Pool Presse SAS se réserve le droit de modifier les présentes CGU à tout moment. 
                Les utilisateurs seront informés des modifications par email ou notification sur la Plateforme.
              </p>
            </div>

            <div>
              <h3 className="font-bold text-gray-800 mb-2">Article 8 - Droit applicable</h3>
              <p>
                Les présentes CGU sont soumises au droit français. En cas de litige, et après tentative 
                de résolution amiable, les tribunaux français seront seuls compétents.
              </p>
            </div>
          </div>
        </section>

        {/* CGV */}
        <section id="cgv" className="bg-white rounded-xl shadow-sm p-8 mb-8">
          <h2 className="text-2xl font-bold text-gray-800 mb-6 border-b pb-4">
            Conditions Générales de Vente (CGV)
          </h2>
          
          <div className="space-y-6 text-gray-700">
            <div>
              <h3 className="font-bold text-gray-800 mb-2">Article 1 - Objet</h3>
              <p>
                Les présentes Conditions Générales de Vente (CGV) régissent les relations commerciales 
                entre Le Pool Presse SAS et ses clients professionnels (établissements d'enseignement) 
                pour l'abonnement à la plateforme SaaS DailyGlobe School.
              </p>
            </div>

            <div>
              <h3 className="font-bold text-gray-800 mb-2">Article 2 - Tarification</h3>
              <div className="bg-gray-50 rounded-lg p-4 mt-2">
                <h4 className="font-bold text-gray-800 mb-3">Tarifs France / Europe :</h4>
                <ul className="space-y-2">
                  <li><strong>4,99 € HT</strong> par élève par mois</li>
                  <li>Dégressif volume : <strong>-20%</strong> à partir de 100 élèves (soit 3,99 € HT/élève/mois)</li>
                  <li>TVA applicable : 20%</li>
                </ul>
                
                <h4 className="font-bold text-gray-800 mb-3 mt-6">Tarifs Afrique (Zone CFA) :</h4>
                <ul className="space-y-2">
                  <li><strong>1 999 FCFA</strong> par élève par mois</li>
                  <li>Dégressif volume : <strong>-20%</strong> à partir de 30 élèves (soit 1 599 FCFA/élève/mois)</li>
                </ul>
              </div>
            </div>

            <div>
              <h3 className="font-bold text-gray-800 mb-2">Article 3 - Modalités de paiement</h3>
              <p>
                Le paiement de l'abonnement mensuel s'effectue :
              </p>
              <ul className="list-disc ml-6 mt-2 space-y-1">
                <li>Par carte bancaire via <strong>Stripe</strong> (paiement sécurisé)</li>
                <li>Par compte <strong>PayPal</strong></li>
                <li>Par virement bancaire pour les établissements (sur demande)</li>
              </ul>
              <p className="mt-2">
                L'abonnement est <strong>mensuel</strong> et renouvelé automatiquement par prélèvement 
                à chaque échéance. Le client peut gérer son abonnement et ses moyens de paiement 
                depuis son espace personnel.
              </p>
            </div>

            <div>
              <h3 className="font-bold text-gray-800 mb-2">Article 4 - Période d'essai</h3>
              <p>
                Une période d'essai gratuite peut être accordée aux nouveaux établissements, 
                d'une durée de 1 à 6 mois selon les conventions établies. Aucun engagement 
                n'est requis pendant cette période. Aucune carte bancaire n'est demandée 
                pour bénéficier de la période d'essai.
              </p>
            </div>

            <div>
              <h3 className="font-bold text-gray-800 mb-2">Article 5 - Durée et résiliation</h3>
              <p>
                L'abonnement est conclu pour une durée indéterminée avec facturation mensuelle. 
                La résiliation peut intervenir <strong>à tout moment</strong>, prenant effet à la fin 
                de la période mensuelle en cours. La résiliation s'effectue depuis l'espace personnel 
                ou par email à support@dailyglobe.school.
              </p>
              <p className="mt-2">
                En cas de résiliation, l'accès à la Plateforme reste actif jusqu'à la fin de la 
                période payée. <strong>Il est recommandé de télécharger et sauvegarder tous les 
                documents et bulletins avant la fin de l'abonnement.</strong>
              </p>
            </div>

            <div>
              <h3 className="font-bold text-gray-800 mb-2">Article 6 - Droit de rétractation</h3>
              <p>
                Conformément à l'article L221-28 du Code de la consommation, le droit de rétractation 
                ne s'applique pas aux contrats de fourniture de contenu numérique non fourni sur un 
                support matériel dont l'exécution a commencé après accord préalable du consommateur.
              </p>
            </div>

            <div>
              <h3 className="font-bold text-gray-800 mb-2">Article 7 - Niveau de service (SLA)</h3>
              <p>
                Le Pool Presse SAS s'efforce d'assurer une disponibilité de la Plateforme de 99% 
                hors maintenances programmées. Les maintenances sont généralement effectuées en 
                dehors des heures de cours (nuit, week-end). En cas d'interruption prolongée 
                non planifiée, un avoir pourra être accordé au prorata du temps d'indisponibilité.
              </p>
            </div>

            <div>
              <h3 className="font-bold text-gray-800 mb-2">Article 8 - Support et assistance</h3>
              <p>
                Le support technique est inclus dans l'abonnement et accessible par email. 
                Le délai de réponse cible est de 48 heures ouvrées. Des sessions de formation 
                et d'accompagnement personnalisé peuvent être proposées sur demande.
              </p>
            </div>

            <div className="bg-amber-50 border-l-4 border-amber-500 p-4">
              <h3 className="font-bold text-amber-800 mb-2">Article 9 - Limitation de responsabilité</h3>
              <p className="text-amber-900">
                Conformément à l'article 4 des CGU, la responsabilité de Le Pool Presse SAS est 
                expressément limitée. L'utilisation de la Plateforme et des contenus générés 
                se fait sous l'entière responsabilité de l'utilisateur. Le Pool Presse SAS 
                ne pourra en aucun cas être tenu responsable des dommages indirects, pertes 
                de données, ou préjudices consécutifs à l'utilisation de la Plateforme.
              </p>
            </div>

            <div>
              <h3 className="font-bold text-gray-800 mb-2">Article 10 - Litiges</h3>
              <p>
                En cas de litige, une solution amiable sera recherchée avant toute action judiciaire. 
                Le client peut contacter le service client à support@dailyglobe.school. 
                À défaut d'accord, les tribunaux du ressort du siège social de Le Pool Presse SAS 
                seront compétents.
              </p>
            </div>
          </div>
        </section>

        {/* Sources */}
        <section id="sources" className="bg-white rounded-xl shadow-sm p-8 mb-8">
          <h2 className="text-2xl font-bold text-gray-800 mb-6 border-b pb-4">
            Sources d'Information
          </h2>
          
          <div className="space-y-6 text-gray-700">
            <div className="bg-blue-50 border-l-4 border-blue-500 p-4 mb-6">
              <p className="text-blue-900">
                <strong>Transparence :</strong> DailyGlobe School utilise des sources d'information 
                publiques et reconnues pour générer ses quiz d'actualité. La sélection des sujets 
                est automatisée et neutre. Voici la liste complète des sources utilisées.
              </p>
            </div>

            {Object.entries(NEWS_SOURCES).map(([category, sources]) => (
              <div key={category} className="mb-6">
                <h3 className="font-bold text-gray-800 mb-3 capitalize flex items-center gap-2">
                  <span className="w-3 h-3 bg-blue-500 rounded-full"></span>
                  {category === 'france' ? 'Actualité France' :
                   category === 'afrique' ? 'Actualité Afrique' :
                   category === 'sport' ? 'Sport' :
                   category === 'economie' ? 'Économie' :
                   category === 'international' ? 'International' : category}
                </h3>
                <div className="grid md:grid-cols-2 gap-3">
                  {sources.map((source, index) => (
                    <div key={index} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                      <div>
                        <a 
                          href={source.url} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          className="font-medium text-blue-600 hover:underline"
                        >
                          {source.name}
                        </a>
                        <p className="text-xs text-gray-500">{source.type}</p>
                      </div>
                      <span className="text-xs bg-gray-200 px-2 py-1 rounded">Source</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}

            <div className="bg-gray-100 rounded-lg p-4 mt-6">
              <h4 className="font-bold text-gray-800 mb-2">Sources personnalisées</h4>
              <p className="text-gray-600 text-sm">
                Les directeurs d'établissement peuvent demander l'ajout de sources d'information 
                spécifiques pour leurs quiz (presse locale, médias spécialisés, etc.). 
                Contactez-nous à sources@dailyglobe.school pour toute demande.
              </p>
            </div>

            <div className="text-sm text-gray-500 mt-4">
              <p>
                <strong>Note :</strong> Les informations extraites de ces sources sont traitées 
                automatiquement par intelligence artificielle. DailyGlobe School ne modifie pas 
                le contenu éditorial des sources et n'est pas responsable des erreurs factuelles 
                qui pourraient y figurer.
              </p>
            </div>
          </div>
        </section>

        {/* Footer */}
        <div className="text-center text-gray-500 text-sm">
          <p>Dernière mise à jour : Février 2026</p>
          <p className="mt-2">
            <Link to="/" className="text-blue-600 hover:underline">Retour à l'accueil</Link>
          </p>
        </div>

      </div>
    </div>
  );
};

export default LegalPage;
